// extracted by mini-css-extract-plugin
module.exports = {"accent":"_i5MF_","interaction":"V7TQJu","icon":"_8AOVTE","suffix":"DMrid_"};